import React, { CSSProperties, useMemo } from "react";
// import { TrackHeightMap } from "@/stores/clip/data/trackConfig";
import store from "@/stores/clipEditor/trackState";
import TrackItem from "./TrackItem";
import playerStore from "@/stores/clip/player";
import { observer } from "mobx-react";
import { toJS } from "mobx";

interface TrackLineProps {
  className?: string;
  style?: React.CSSProperties;
  isMain?: boolean;
  lineType?: string;
  lineIndex?: number;
  lineData?: Array<any>;
}

const TrackLine: React.FC<TrackLineProps> = ({
  className = "",
  style = {},
  isMain = false,
  lineType = "",
  lineIndex = 0,
  lineData = [],
}) => {
  // console.log("lineData========", lineData);

  // 判断当前轨道是否被选中
  const isActive = useMemo(() => {
    return store.selectTrackItem.line === lineIndex;
  }, [toJS(store.selectTrackItem), lineIndex]);

  const tarckType = useMemo(() => {
    return store.trackList[lineIndex].type;
  }, [toJS(store.trackList), lineIndex]);

  const mainTrackStye = useMemo(() => {
    return {
      position: isMain ? "sticky" : "relative",
      zIndex: isMain ? 2 : "",
    } as CSSProperties;
  }, [isMain]);

  // 计算轨道高度
  // const trackHeight = useMemo(() => TrackHeightMap.get(lineType), [lineType]);

  // 计算轨道样式
  const trackLineClass = useMemo(() => {
    const baseClass = "trackLine";
    const activeClass = isActive ? "active" : "";
    console.log("store.insertInfo", store.insertInfo.insertIndex, lineIndex);

    let insertLineClass;
    if (store.insertInfo.insertIndex === store.trackList.length) {
      if (lineIndex === store.trackList.length - 1) {
        insertLineClass = "bottom-line";
      }
    }
    if (store.insertInfo.insertIndex === lineIndex) {
      if (store.insertInfo.isNewLine) {
        insertLineClass = "new-line";
      } else {
        insertLineClass = "in-line";
      }
    }

    return `${baseClass} ${activeClass} ${insertLineClass} `;
  }, [
    isActive,
    isMain,
    store.insertInfo.insertIndex,
    store.insertInfo.isNewLine,
  ]);

  return (
    <div
      className={`${trackLineClass} ${className} `}
      data-index={lineIndex}
      data-type={lineType}
      style={{
        position: "relative",
        margin: "0 0 3px 10px",
        height: tarckType === "video" ? 41 : 34,
        background: "#fff",
        ...style,
        ...mainTrackStye,
      }}
    >
      {/* {JSON.stringify(lineData)} */}
      {/* 渲染轨道项 */}
      {lineData.map((item, index) => (
        <TrackItem
          key={item.id}
          lineIndex={lineIndex}
          itemIndex={index}
          trackItem={item}
        />
      ))}
    </div>
  );
};

export default observer(TrackLine);
